import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import styles from "../../_css/UI.module.css";
import { HOME_DATA_SESSION_TRACKER } from "../../data/staticDataHome";
import { useSelector } from "react-redux";

// const data = [
//   { name: "English", value: usedSessions },
//   { name: "Arabic", value: totalSessions - usedSessions },
// ];
const COLORS = ["#234A93", "#ECEFF2"];

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
}) => {
  if (index === 0) {
    // English (right side)
    const offset = 8;
    const lineLength = 18;
    const angle = (-midAngle * Math.PI) / 180;
    const sx = cx + outerRadius * Math.cos(angle);
    const sy = cy + outerRadius * Math.sin(angle);
    const ex = cx + (outerRadius + offset + lineLength) * Math.cos(angle);
    const ey = cy + (outerRadius + offset + lineLength) * Math.sin(angle);
    const lx = cx + (outerRadius + offset + lineLength) * Math.cos(angle);
    const ly = cy + (outerRadius + offset + lineLength) * Math.sin(angle);
    return (
      <g>
        <line
          x1={sx}
          y1={sy}
          x2={ex}
          y2={ey}
          stroke="#E5E7EB"
          strokeWidth={2}
        />
        <text
          x={lx}
          y={ly}
          fill="#234A93"
          textAnchor="start"
          dominantBaseline="central"
          fontSize={24}
          fontWeight={700}
        >
          70%
        </text>
      </g>
    );
  } else {
    // Arabic (left side)
    const offset = 8;
    const lineLength = 18;
    const angle = (-midAngle * Math.PI) / 180;
    const sx = cx + outerRadius * Math.cos(angle);
    const sy = cy + outerRadius * Math.sin(angle);
    const ex = cx + (outerRadius + offset + lineLength) * Math.cos(angle);
    const ey = cy + (outerRadius + offset + lineLength) * Math.sin(angle);
    const lx = cx + (outerRadius + offset + lineLength) * Math.cos(angle);
    const ly = cy + (outerRadius + offset + lineLength) * Math.sin(angle);
    return (
      <g>
        <line
          x1={sx}
          y1={sy}
          x2={ex}
          y2={ey}
          stroke="#E5E7EB"
          strokeWidth={2}
        />
        <text
          x={lx}
          y={ly}
          fill="#FFC94D"
          textAnchor="end"
          dominantBaseline="central"
          fontSize={24}
          fontWeight={700}
        >
          30%
        </text>
      </g>
    );
  }
};

const SessionTracker = ({ totalSessions, usedSessions }) => {
  const lang = useSelector((state) => state.language.lang);
  const { sessionTrackerTitle, sessionTrackerSubTitle } = HOME_DATA_SESSION_TRACKER[lang];
  const data = [
    { name: "English", value: usedSessions },
    { name: "Arabic", value: totalSessions - usedSessions },
  ];
  return (
    <div className={styles.sessionTrackerCard}>
        <h3 className={styles.sessionTrackerTitle}>{sessionTrackerTitle}</h3>
      <p className={styles.sessionTrackerSubTitle}>
        {sessionTrackerSubTitle.replace("{usedSessions}", usedSessions).replace("{totalSessions}", totalSessions)}
      </p>
      <ResponsiveContainer width="100%" height={240}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={70}
            outerRadius={90}
            startAngle={90}
            endAngle={-270}
            dataKey="value"
            labelLine={false}
            // label={renderCustomizedLabel}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Pie>
          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize={48}
            fontWeight="bold"
            fill="#333"
          >
            {usedSessions}
          </text>
        </PieChart>
      </ResponsiveContainer>
      {/* <div className={styles.legendRow}>
      <span className={styles.legendDot} style={{ background: COLORS[1] }} /> Arabic
      <span className={styles.legendDot} style={{ background: COLORS[0], marginLeft: 24 }} /> English
    </div> */}
    </div>
  );
};

export default SessionTracker;
